define('modules/accounts/security/index',['require','exports','module','./model','./detail/view'],function(require, exports, module) {
    "use strict";

    var Model = require("./model");
    
    module.exports = {
        View: require("./detail/view"),
        Model: Model        
    };

});
